<template>
  <div ref='echarts' id="echart" :style="size">

  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'ECharts',
  props: {
    options: Object,
    size: Object
  },
  created() {
    /* this.$nextTick(() => {
       this.myChart = echarts.init(document.getElementById("echart"));
     })*/
  },
  mounted () {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(this.$refs.echarts);
    // 使用刚指定的配置项和数据显示图表。
    this.myChart.setOption(this.options);

    // 图表自适应
    const self = this;//因为箭头函数会改变this指向，指向windows。所以先把this保存
    setTimeout(() => {
      window.addEventListener('resize', function() {
        self.chart = self.$echarts.init(self.$refs.echarts);
        self.chart.resize();
      })
    },10)


    /*  let that=this
      window.addEventListener("resize", function () {
        that.myChart.resize();
      });*/


  },
  data: function () {
    return {
      myChart: {}
    }
  },
  watch: {
    // 监听options改变，重新生成图表
    options: function () {
      this.myChart.setOption(this.options)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
